import axios from "axios";
import { useQuery } from "react-query";

const api_base_url = process.env.REACT_APP_API_BASEURL + "/ProducerCode";

export const searchProducerCodes = async ({ queryKey }) => {
  const [_key, filters] = queryKey;

  const queryStrings = new URLSearchParams();

  if (!filters) {
    const res = await axios.get(`${api_base_url}/SearchProducerCode`);
    return res.data;
  }

  const franchiseVal = filters.selectedFranchiseConfie?.value;
  const franchiseMap: Record<number, Record<string, string>> = {
    1: { IsFranchise: "true", FranchiseTypeId: "2" },
    3: { IsFranchise: "true", FranchiseTypeId: "1" },
  };

  if (franchiseVal !== undefined && franchiseVal >= 0) {
    const config = franchiseMap[franchiseVal] || { IsFranchise: "false" };
    Object.entries(config).forEach(([k, v]) => queryStrings.append(k, v));
  }

  const allowedKeys = new Set([
    "CarrierName",
    "OfficeName",
    "OfficeCode",
    "State",
    "Status",
    "ProducerCode",
    "MAProducerCode",
    "AcquisitionName",
    "BillingId",
    "DistributionChannelId",
  ]);
  const aliasMap: Record<string, string> = { State: "States" };

  Object.entries(filters).forEach(([key, value]) => {
    if (!allowedKeys.has(key) || value == null || value === "") return;

    const paramName = aliasMap[key] || key;

    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (
          typeof v === "string" ||
          typeof v === "number" ||
          typeof v === "boolean"
        ) {
          queryStrings.append(paramName, String(v));
        }
      });
    } else if (
      typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "boolean"
    ) {
      queryStrings.append(paramName, String(value));
    }
  });

  const res = await axios.get(`${api_base_url}/SearchProducerCode`, {
    params: queryStrings,
  });

  return res.data;
};

export const useSearchProducerCode = ({ filterParams }) => {
  return useQuery(["SearchProducerCode", filterParams], searchProducerCodes, {
    refetchOnWindowFocus: false,
    enabled: false,
  });
};
